import type { AppModule } from '@/app/app-module.types';
import { SalesIcon, ContractIcon } from '@/shared/icons';
import { SALES_ROLES } from '@/shared/guards/roles';
import { salesContainer } from './di/container';
import { SalesRepositoryToken } from './di/tokens';
import { salesRoutes } from './presentation/routes';

/**
 * Módulo de Vendas (Sales Admin). Consome a área de leitura do módulo `sales` do
 * monolith (`/admin/sales/*`). Aparece no grupo "Gerenciamento" da sidebar para
 * `SALES_ROLES` — hoje só os curingas administrativos, espelhando o
 * `@Roles(...SALES_READ_ROLES)` do `SalesAdminReadController`. Ler e agir têm a
 * mesma alçada desde que o eixo `salesViewer` × `salesEditor` saiu do catálogo,
 * então não há um gate de escrita separado dentro das telas.
 */
export const salesModule: AppModule = {
  name: 'sales',

  register(container) {
    container.register(SalesRepositoryToken, () => salesContainer.repository);
  },

  routes: salesRoutes,

  menu: [
    {
      label: 'Contratos',
      to: '/contracts',
      icon: ContractIcon,
      section: 'commercial',
      order: 1,
      roles: SALES_ROLES,
    },
    {
      label: 'Vendas',
      to: '/sales',
      icon: SalesIcon,
      section: 'commercial',
      order: 2,
      roles: SALES_ROLES,
    },
    {
      label: 'Ofertas',
      to: '/offers',
      icon: SalesIcon,
      section: 'commercial',
      order: 4,
      roles: SALES_ROLES,
    },
    {
      label: 'Webhook Inbox',
      to: '/sales/webhook-inbox',
      icon: SalesIcon,
      section: 'operations',
      order: 2,
      roles: SALES_ROLES,
    },
  ],
};
